import React from 'react';
import '../Assests/contact.css';



function Contact(){
      
        return (
           
            <footer className="container-fluid">
            <div className="footer-top" >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-sm-6">
                            <div className="address">
                                <h3>Contact</h3>
                                <p className="mb-4 mt-4">Lahore, Pakistan</p>
                                {/* <p><strong>Phone:</strong> +92 3314200396</p> */}
                                <p><strong>Email:</strong> ithelper67@gmail.com</p>
                            </div>
                        </div>

                        <div className="col-lg-2 col-sm-6 footer-menus">
                            <h4>Useful Links</h4>
                            <ul>
                                <li><i className="fa fa-check"></i> <a href="#">Home</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">About us</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Projects</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Channel</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Privacy policy</a></li>
                            </ul>
                        </div>

                        <div class="col-lg-3 col-sm-6 footer-menus">
                            <h4>Our Services</h4>
                            <ul>
                                <li><i className="fa fa-check"></i> <a href="#">Web Design</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Web Development</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Product Management</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Marketing</a></li>
                                <li><i className="fa fa-check"></i> <a href="#">Graphic Design</a></li>
                            </ul>
                        </div>

                        <div class="col-lg-4 col-sm-6 newsletter">
                            <h4>Social Contact</h4>
                            <div class="social-links mt-3">
                                <a href="https://www.facebook.com/IT_Helper-109427717894777"><i className='fa fa-facebook-f'></i></a>
                                <a href="#"><i className="fa fa-twitter"></i></a>
                                <a href="https://www.linkedin.com/in/qurat-ul-ain-2a7b4114b/"><i className="fa fa-linkedin"></i></a>
                                <a href="#"><i className="fa fa-instagram"></i></a>
                                <a href="#"><i className  ="fa fa-pinterest-p"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p className="text-center mb-2">&copy; Copyright <strong>Qurat-ul-ain</strong>. All Rights Reserved</p>
                            <p className="text-center mb-0">Created by Qurat-ul-ain</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        
          
        );
    }


export default Contact;